<template>
  <div class="c-fa-new-step5 header-5">
    Informasi Tambahan
    <div class="c-fa-new-step5-content" style="margin-bottom: 20px;">
      Informasi tambahan ini akan membantu kami untuk memberikan agen yang tepat untuk Anda.
      <div class="age-5 mt-1">
        <span style="font-weight: 700">
          UMUR 
        </span>
        <span style="font-style: italic;">
          (OPSIONAL)
        </span>
      </div>
      <div class="form-group">
        <input 
          type="text"
          class="form-control form-control-5" 
          id="pwd" 
          placeholder="Masukkan umur Anda"
          :value="chooseAge"
          @keyup="setAge"
        >
      </div>
      <div v-if="errorAge && textErrorAge != ''" class="form-group col-sm-12 text-error">
        <img src="../../../../../assets/images/svg/ic-warning.svg" style="padding-right: 10px;">
        {{ textErrorAge }}
      </div>
      <div class="age-5 mt-1">
        <span style="font-weight: 700">
          Budget 
        </span>
        <span style="font-style: italic;">
          (OPSIONAL)
        </span>
      </div>
      <div class="input-group ">
        <div class="input-group-prepend">
          <div class="input-group-text">Rp.</div>
        </div>
        <input type="text" 
          class="form-control form-control-5"
          id="inlineFormInputGroup"
          placeholder="Masukkan budget Anda dalam sebulan"
          :value="chooseBudget"
          @keyup="setBudget"
        >
      </div>
      <div v-if="errorBudget && textErrorBudget != ''" class="form-group col-sm-12 text-error">
        <img src="../../../../../assets/images/svg/ic-warning.svg" style="padding-right: 10px;">
        {{ textErrorBudget }}
      </div>
    </div>
    <div class="age-5 mt-1">
      <span style="font-weight: 700">
        CALON TERTANGGUNG 
      </span>
      <span style="font-style: italic;">
        (OPSIONAL)
      </span>
    </div>
    <div class="row mt-1">
      <div class="col-sm-12 scroll-down" style="padding-bottom: 10px;">
        <div
          v-for="(relation, key) in relations"
          :key="key"
          class="form-check form-check-inline form-control retangle-5 form-control-5" 
          style="text-align:left; cursor:pointer;"
          @click="setIntendedCode(relation.custom_code)"
        >
          <input
            class="form-check-input"
            type="radio"
            name="inlineRadioOptions"
            :id="inputId(key)"
            :value="relation.custom_code"
            :checked="relation.custom_code === intendedCode"
          >
          <label class="form-check-label" for="inlineRadio1">{{relation.text}}</label>
        </div>
      </div>
    </div>
    <button
      class="button-fixed-1 button-continue" :disabled="errorAge || errorBudget"  style="margin-top: 20px;"
      @click="nextStep()"
    >
      LANJUTKAN
    </button>
  </div>
</template>

<script>

export default {
  name: 'Step5',
  data() {
    return {
      relations: [],
      intendedCode: null,
      chooseAge: null,
      chooseBudget: null,
      textErrorAge: '',
      textErrorBudget: '',
      errorAge: false,
      errorBudget: false,
      env: '',
    }
  },
  props: {
    age: {
      type: Number,
      default: null,
    },
    budget: {
      type: Number,
      default: null,
    },
  },
  created() {
    this.relations = [
      {
        id: 1,
        custom_code: "rel_self",
        text: "Diri Sendiri"
      },
      {
        id: 2,
        custom_code: "rel_wife",
        text: "Istri"
      },
      {
        id: 3,
        custom_code: "rel_husband",
        text: "Suami"
      },
      {
        id: 4,
        custom_code: "rel_child",
        text: "Anak"
      },
      {
        id: 5,
        custom_code: "rel_older_siblings",
        text: "Kakak"
      },
      {
        id: 6,
        custom_code: "rel_younger_siblings",
        text: "Adik"
      }
    ]
  },
  methods: {
    setIntendedCode(code) {
      this.intendedCode = code;
    },
    setAge(event) {
      var temp =  event.target.value.replace(/[^0-9\-]/g,'');
      this.chooseAge  = temp.replace('-','');
      event.target.value = this.chooseAge;

      if( Number(event.target.value) > 99) {
        this.textErrorAge = 'Umur tidak boleh dari 99 tahun';
        this.errorAge = true;
      } else {
        this.errorAge = false;
      }
    },
    setBudget(event) {
      var temp =  event.target.value.replace(/[^0-9\-]/g,'');
      this.chooseBudget  = temp.replace('-','');
      event.target.value = this.chooseBudget;
    },
    nextStep() {
      this.$emit('submit:age', this.chooseAge);
      this.$emit('submit:budget', this.chooseBudget);
      this.$emit('submit:intended-code', this.intendedCode);
    },
    inputId(idx) {
      return `relationship${idx}`;
    }
  }
};
</script>